import { Alert, Loader, Stack, Text, Title } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";
import { OrganizationMembersTab } from "../../components/OrganizationMembersTab/OrganizationMembersTab";
import { GlassCard } from "../../components/UI/GlassCard";
import {
	type OrganizationRole,
	useGetCurrentUserAndOrganizationsQuery,
} from "../../graphql/generated/types.gen";
import { useActiveOrganization } from "../../hooks/useActiveOrganization";

export const Route = createFileRoute("/settings/members")({
	component: MembersRoute,
});

function MembersRoute() {
	const { activeOrganization, loading } = useActiveOrganization();
	const { data: userData } = useGetCurrentUserAndOrganizationsQuery();
	const currentUserId = userData?.currentUser?.id ?? "";

	if (loading) {
		return (
			<div className="flex items-center justify-center min-h-[40vh]">
				<Loader size="lg" />
			</div>
		);
	}

	return (
		<Stack gap="lg">
			<Stack gap="xs">
				<Title order={2}>Members</Title>
				<Text c="dimmed">People in your organization.</Text>
			</Stack>

			{activeOrganization ? (
				<GlassCard padding="lg">
					<OrganizationMembersTab
						organizationId={activeOrganization.id}
						currentUserRole={activeOrganization.role as OrganizationRole}
						currentUserId={currentUserId}
					/>
				</GlassCard>
			) : (
				<Alert color="blue">
					Select an organization to manage its members.
				</Alert>
			)}
		</Stack>
	);
}
